<template>
  <div>
    <div
      v-for="(setParams, setIndex) in sets"
      :key="'set'+setIndex"
      class="align-center mb-2"
    >
      <div
        class="grey--text text--darken-1 d-inline-block"
        style="width: 50px"
        :class="{ 'caption': dense, 'text-body-1': !dense }"
      >
        {{ $t("training_builder.configure.set", {set: setIndex + 1}) }}:
      </div>

      <exercise-param-label-helper
        :label="$t('reps.label')"
        :dense="dense"
        :param="setParams.NMRP"
      />

      <exercise-param-label-helper
        :label="$t('rep_work.label')"
        :dense="dense"
        :param="setParams.WRPRDR"
        suffix="s"
      />

      <exercise-param-label-helper
        :label="$t('event_type.rest')"
        :dense="dense"
        :param="setParams.RSPRDR"
        suffix="s"
      />

      <exercise-param-label-helper
        :label="$t('rest_after_set.label')"
        :dense="dense"
        :param="setParams.RSSTDR"
        suffix="s"
      />

      <exercise-param-label-helper
        :label="$t('training_builder.dropdown.court_area.title')"
        :dense="dense"
        :param="setParams.CRTAREA"
      />

      <exercise-param-label-helper
        :label="$t('training_builder.dropdown.intensity.title')"
        :dense="dense"
        :param="setParams.INTST"
      />

      <exercise-param-label-helper
        :label="$t('training_builder.dropdown.format.title')"
        :dense="dense"
        :param="setParams.FRMT"
      />

      <exercise-param-label-helper
        :label="$t('training_builder.dropdown.contact.title')"
        :dense="dense"
        :param="setParams.CNTCT ? $t('training_builder.rm.yes') : $t('training_builder.rm.no')"
      />
    </div>
  </div>
</template>
<script>

import ExerciseParamLabelHelper from '@/components/training-builder/ExerciseParamLabelHelper.vue'

export default {
  name: 'BasketballParamsView',
  components: { ExerciseParamLabelHelper },
  props: {
    sets: {
      type: Array,
      required: true
    },
    dense: {
      type: Boolean,
      default: false
    },
    hasRealizations: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    user() {
      return this.$store.getters[this.$storeGetters.AUTH_USER]
    }
  }
}
</script>
